import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import { GiftcardsCategoryViewComponent } from '../../module/giftcards/giftcards-category-view.component';
import { CategoryViewComponent } from './category/category-view.component';
import { Error404Component } from './error-404.component';
import { PageViewComponent } from './page/page-view.component';
import { ProductViewComponent } from './product/view/product-view.component';
import { StoreViewComponent } from './store/view/store-view.component';

@Component({
    selector: 'catalog-view',
    templateUrl: 'catalog-view.html',
    standalone: true,
    imports: [
        CategoryViewComponent,
        CommonModule,
        Error404Component,
        GiftcardsCategoryViewComponent,
        PageViewComponent,
        ProductViewComponent,
        StoreViewComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogViewComponent extends CatalogViewComponentDef {}
